<template>
  <div>
    <div class="pdfok" id="pdfok" v-if="pdfok"></div>
    <div v-if="dataover222" id="printMe" style=" width: 21cm; margin: 0 auto;">
      <div v-for="(item, index) in reportData" :key="index">
        <div class="stuContact A4Container flexCloumnCenter pageBreak_no">
          <div class="title">{{ year_month }}月学生访谈记录</div>
          <div class="form">
            <div class="flexCloumnSingleCenter" style="width: 100%;height: 100%;">
              <el-row class="el-row1" style="width: 100%;padding: 0 10px;height:40px;">
                <el-col :span="6" class="flexStart" style="height:100%;">
                  <div class="flexCenter">学号：</div>
                  <div class="flex_1 overMoreLine"
                       style="white-space: normal;word-break: break-all;padding: 0 5px;box-sizing: border-box;">
                    {{item.stu_code}}
                  </div>
                </el-col>
                <el-col :span="6" class="flexStart" style="height:100%;">
                  <div class="flexCenter">学生姓名：</div>
                  <div class="flex_1 overMoreLine"
                       style="white-space: normal;word-break: break-all;padding: 0 5px;box-sizing: border-box;">
                    {{ item.stu_name }}
                  </div>
                </el-col>
                <el-col :span="6" class="flexStart" style="height:100%;">
                  <div class="flexCenter">班级：</div>
                  <div class="flex_1 overMoreLine"
                       style="white-space: normal;word-break: break-all;padding: 0 5px;box-sizing: border-box;">
                    {{ item.class_name }}
                  </div>
                </el-col>
                <el-col :span="6" class="flexStart" style="height:100%;">
                  <div class="flexCenter">家长姓名：</div>
                  <div class="flex_1 overMoreLine"
                       style="white-space: normal;word-break: break-all;padding: 0 5px;box-sizing: border-box;">
                    {{ item.parent_name || '' }}
                  </div>
                </el-col>
              </el-row>
              <el-row class="" style="width: 100%;padding: 0 10px;height:40px;border-bottom: solid 1px #000">
                <el-col :span="6" class="flexStart" style="height:100%;">
                  <div class="flexCenter">访谈方式：</div>
                  <div class="flex_1 overMoreLine"
                       style="white-space: normal;word-break: break-all;padding: 0 5px;box-sizing: border-box;">
                    {{item.contact_type | getContactType}}
                  </div>
                </el-col>
                <el-col :span="12" class="flexStart" style="height:100%;">
                  <div class="flexCenter">访谈时间：</div>
                  <div class="flex_1 overMoreLine"
                       style="white-space: normal;word-break: break-all;padding: 0 5px;box-sizing: border-box;">
                    {{item.contact_time}}
                  </div>
                </el-col>
                <el-col :span="6" class="flexStart" style="height:100%;">
                  <div class="flexCenter">填表人：</div>
                  <div class="flex_1 overMoreLine"
                       style="white-space: normal;word-break: break-all;padding: 0 5px;box-sizing: border-box;">
                    {{item.username}}
                  </div>
                </el-col>
              </el-row>

              <div style="width: 100%;height: calc( 100% - 132px );">
                <div class="content"
                     style="width:100%;height: 100%;overflow: hidden;box-sizing: border-box;position: relative;">
                  <div class="content_real_values flex_1"
                       style="width: unset;white-space: normal;">{{item.content || '-'}}
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>




    <!--    <el-button v-print="'#printMe'" type="primary" style="position: fixed;top: 60px;right: 10px;z-index: 999;">-->
    <!--      打印-->
    <!--    </el-button>-->

  </div>
</template>

<script>
import Yuebao from './com_stu/yuebao'
import YuebaoKPI from './com_stu/yuebao_kpi'
import Zhoubao from './com_stu/zhoubao'

export default {
  name: 'export',
  components: {
    Zhoubao,
    Yuebao,
    YuebaoKPI,
  },
  data() {
    return {
      pdfok: false,
      show_dev: false,
      show_dev1: false,
      dataover222: true,
      showIdentify: false,
      printObj: {
        id: 'printMe',
        popTitle: '',
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
      },
      userid: '',

      stuInfo: {},
      yuebao: [{}],
      zhoubao: [{}],
      chinaCitys: [],
      // 填入导出的pdf文件名和html元素
      pdfTitle: '试卷1',
      pdfSelector: '#printMe',
      pmid:'',
      report_type: '',
      reportData: [],
      info: {},
      year_month: ''
    }
  },
  filters: {
    getContactType(val) {
      let obj = {'1': '电话','2':'视频','3':'面谈','4':'qq','5':'微信'}
      return obj[val] || ''
    },
  },
  mounted() {
    let id = this.getParams('id')
    let pmid = this.getParams('pmid')
    let yearMonth = this.getParams('year_month')
    this.year_month = yearMonth
    this.pmid = pmid
    this.getDataList(id, pmid,yearMonth)

  },
  methods: {
    //过滤特殊字符, 校验所有输入域是否含有特殊符号
    stripscript(s) {
      var pattern = new RegExp('[&mdash;]')
      var rs = ''
      for (var i = 0; i < s.length; i++) {
        rs = rs + s.substr(i, 1).replace(pattern, '-')
      }
      return rs
    },
    findDeep(list, iid) {
      for (let i in list) {
        if (list[i].value === iid) {
          return [list[i]]
        }
        if (list[i].children != null) {
          let node = this.findDeep(list[i].children, iid);
          if (node !== undefined) {
            return node.concat(list[i])
          }
        }
      }

    },
    getDataList(classId, pmid,yearMonth) {
      let _this = this
      this.$http.post('/api/get_stu_interview_record', {
        class_id: parseInt(classId) ? parseInt(classId) : classId,
        pmid: parseInt(pmid),
        year_month: yearMonth
      }).then(res => {
        if (res.data) {
          this.reportData = res.data;
        }

        this.$nextTick(() => {
          setTimeout(() => { _this.pdfok = true }, 500)
        })

      })

    },

    getParams(name) {
      let n_url = window.location.href
      n_url = n_url.replace('/#', '')
      if (n_url.indexOf('?') > 0) {
        n_url = n_url.split('?')[1]
      }
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
      var r = n_url.match(reg)
      if (r != null) return unescape(r[2])
      return null
    },
    //分割数组 arr：原数组  num：分割后每个数组里的数据条数
    util_spliceArrByN(arr, num) {
      var _arr = []
      while (arr.length) {
        _arr.push(arr.splice(0, num))
      }
      return _arr
    },
    //数组按某属性分组
    groupBy(array, f) {
      let groups = {}
      array.forEach(function (o) {
        let group = JSON.stringify(f(o))
        groups[group] = groups[group] || []
        groups[group].push(o)
      })
      return Object.keys(groups).map(function (group) {
        return groups[group]
      })
    }
  }
}
</script>
<style lang="less" type="text/less">
@import "/public/css/pdf_default";
</style>
<style lang="less" scoped>
.stuContact {
  font-size: 20px;
  box-sizing: border-box;
  margin: 0 auto;
  padding: 25px 0;

  .title {
    font-size: 20px;
    line-height: 50px;
  }

  .form {
    width: calc(100% - 50px);
    height: calc(100% - 50px);
    border: 1px solid #000;
    border-top: 0;
    overflow: hidden;

    div {
      font-size: 14px;
      color: #323232;
      box-sizing: border-box;
    }

    .content {
      width: 100%;
      height: 100%;
      padding: 10px;
      white-space: break-spaces;
      word-break: break-all;
      overflow: hidden;
    }

    .el-row1 {
      border-top: 1px solid #000;
    }
  }

  .col-row {
    width: 100%;
    margin: 0;
    padding: 0;
  }
}
</style>
